export default [
    { value: 'Comercial', text: 'Comercial' },
    { value: 'Particular', text: 'Particular' }
]